var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var SelectionAccuracy = require("../../selection/selectionAccuracy.js");
var cio_datamodel = require("cio-datamodel");
if (typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");

var GridInteraction = require("../../../abstract/gridInteraction.js");
var AbstractPosAngleInteractionModel = require("../../../abstract/abstractPosAngleInteractionModel.js");
var cio_config = require("cio-config");
var SnapLineType = require("./../../snap/snapLineType.js");

var RectangleInteractionModel = function (rectData, editorModel, options) {
    AbstractPosAngleInteractionModel.call(this, rectData, editorModel);

    this.addGridInteraction(this, editorModel);

    this.origin = editorModel.origin();
    this.editorModel = editorModel;
    this.options = options || {};

    this.showStrokeWidth = this.shadow("showStrokeWidth",
        function () {
            return this.data.strokeWidth() / this.origin.getGridFactor();
        },
        function (strokeWidth) {
            return this.data.strokeWidth(Math.abs(strokeWidth || 0) * this.origin.getGridFactor());
        },
        [this.data.strokeWidth, this.origin.grid_unit]
    );

    this.showWidth = this.shadow("showWidth",
        function () {
            return this.data.width() / this.origin.getGridFactor();
        },
        function (width) {
            return this.data.width((width || 0) * this.origin.getGridFactor());
        },
        [this.data.width, this.origin.grid_unit]
    );

    this.showHeight = this.shadow("showHeight",
        function () {
            return this.data.height() / this.origin.getGridFactor();
        },
        function (height) {
            return this.data.height((height || 0) * this.origin.getGridFactor());
        },
        [this.data.height, this.origin.grid_unit]
    );

    this.showRoundness = this.shadow("showRoundness",
        function () {
            return this.data.rx() / this.origin.getGridFactor();
        },
        function (value) {
            var r = Math.abs(value || 0) * this.origin.getGridFactor();
            if (r >= this.data.width() / 2 || r >= this.data.height() / 2) {
                r = Math.min(this.data.width(), this.data.height()) / 2;
            }
            this.data.rx(r);
            return this.data.ry(r);
        },
        [this.data.rx, this.data.ry, this.origin.grid_unit]
    );
};
lib_core.inherit(RectangleInteractionModel, AbstractPosAngleInteractionModel);
lib_core.mixin(RectangleInteractionModel, GridInteraction);
lib_core.JsonParser.registerClass(RectangleInteractionModel, "RectangleInteractionModel");

module.exports = RectangleInteractionModel;

RectangleInteractionModel.prototype.getInspectorElements = function () {
    var inspectorElements = AbstractPosAngleInteractionModel.prototype.getInspectorElements.call(this);

    inspectorElements.input_elements.push(
        {
            label: 'Width',
            type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember: this.showWidth,
            datatype   : cio_config.types.positive_float,
            unitmember : this.origin.showUnitString
        },
        {
            label: 'Height',
            type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember: this.showHeight,
            datatype   : cio_config.types.positive_float,
            unitmember : this.origin.showUnitString
        },
        {
            label: 'Stroke Width',
            type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember: this.showStrokeWidth,
            datatype    : cio_config.types.positive_float,
            unitmember : this.origin.showUnitString
        },
        {
            label: 'Fill',
            type: ui_extensions.InspectorInputType.CHECKBOX,
            datamember: this.data.fill
        },
        {
            label: 'Roundness',
            type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember: this.showRoundness,
            datatype    : cio_config.types.positive_float,
            unitmember : this.origin.showUnitString
        }
    );

    inspectorElements.help_elements = {
        'name': 'Rectangle'
    };

    return inspectorElements;
};

RectangleInteractionModel.prototype.getSnapSet = function (type) {
    var snapSet = AbstractPosAngleInteractionModel.prototype.getSnapSet.call(this, type);

    // TODO
    // switch (type) {
    //     case SnapLineType.FROM:
    //         this.data.getVertices().forEach(function (pos) {
    //             snapSet.add(pos, 1);
    //         });
    //         break;
    //     case SnapLineType.TO:
    //         // snapSet.addHor(this.data.pos(), 1);
    //         // snapSet.addVer(this.data.pos(), 1);
    //         break;
    // }

    return snapSet;
};

RectangleInteractionModel.prototype.width = function (val) {
    return this.data.width(val);
};

RectangleInteractionModel.prototype.height = function (val) {
    return this.data.height(val);
};
